export default{
    // Default texts
    "general.signal": "Signal",
    "general.view": "View",
    "general.slogan": "The power is in our algorithms",
    "general.copyright": "All rights reserved",
    "general.close": "Close",
    "general.error": "Error",
    "general.configuration": "Configuration",
    "general.ok": "OK",
    "general.clear": "CLEAR",
    "general.save": "SAVE",
    "general.cancel": "CANCEL",
    "general.na": "N/A",
    "general.default.errorMessage": "An error occurred while retrieving data. Please try again in a few seconds and if the error persists, contact us.",

    // Sidebar menu
    "sidebar.menu.home": "Home",
    "sidebar.menu.mySignals": "My Signals",
    "sidebar.menu.potentialSignals": "Potential Signals",
    "sidebar.menu.activeSignals": "Active Signals",
    "sidebar.menu.closedSignals": "Closed Signals",
    "sidebar.menu.marketSentiment": "Market Sentiment",
    "sidebar.menu.statistics": "Statistics",
    "sidebar.menu.trackRecord": "Our Track Record",

    // Login page
    "login.titleUpperCase": "LOGIN",
    "login.welcome": "Welcome",
    "login.username": "Username",
    "login.password": "Password",
    "login.signIn": "Sign In",

    // Home page
    "home.market.open": "Stock market is currently open",
    "home.market.close": "Stock market is currently close",

    "home.todaySignal.title": "Last Session",
    "home.todaySignal.breakouts": "Breakouts",
    "home.todaySignal.above": "Above",
    "home.todaySignal.below": "Below",

    "home.potentialSignal.title": "Potential Signals",
    "home.potentialSignal.high": "High",
    "home.potentialSignal.likey": "Likely",
    "home.potentialSignal.eventual": "Eventual",

    "home.mainIndices.title": "Main Indices",
    "home.mainIndices.dow": "DOW",
    "home.mainIndices.nasdaq": "NASDAQ",
    "home.mainIndices.sp500": "S&P 500",

    "home.marketSentiment.title": "Market Sentiment",
    "home.marketSentiment.today": "Today",
    "home.marketSentiment.week": "Week",
    "home.marketSentiment.month": "Month",

    "home.recentSignals.title": "Recent Signals",
    "home.recentSignals.sector": "SECTOR",
    "home.recentSignals.ticker": "TICKER",
    "home.recentSignals.signalDate": "SIGNAL DATE",
    "home.recentSignals.signalPrice": "SIGNAL PRICE",
    "home.recentSignals.currentPrice": "CURRENT PRICE",
    "home.recentSignals.volume": "VOLUME",
    "home.recentSignals.rvol": "RVOL",
    "home.recentSignals.status": "STATUS",
    "home.recentSignals.technical": "TECHNICAL",
    "home.recentSignals.fundamental": "FUNDAMENTAL",
    "home.recentSignals.strength": "STRENGTH",
    "home.recentSignals.table.empty": "No new potential signals have been activated today",

    "home.potentialSignalSummary.title": "Potential Signal Summary",
    "home.potentialSignalSummary.ticker": "TICKER",
    "home.potentialSignalSummary.sector": "SECTOR",
    "home.potentialSignalSummary.currentPrice": "CURRENT PRICE",
    "home.potentialSignalSummary.signalPrice": "SIGNAL PRICE",
    "home.potentialSignalSummary.signalVolume": "SIGNAL VOLUME",
    "home.potentialSignalSummary.currentVolume": "CURRENT VOLUME",
    "home.potentialSignalSummary.technical": "TECHNICAL",
    "home.potentialSignalSummary.fundamental": "FUNDAMENTAL",
    "home.potentialSignalSummary.strength": "STRENGTH",

    "home.trackRecord.title": "Recent Track Record",
    "home.trackRecord.ticker": "TICKER",
    "home.trackRecord.sector": "SECTOR",
    "home.trackRecord.signalDate": "SIGNAL DATE",
    "home.trackRecord.signalPrice": "SIGNAL PRICE",
    "home.trackRecord.finishDate": "FINISH DATE",
    "home.trackRecord.peakPrice": "PEAK PRICE",
    "home.trackRecord.totalDays": "TOTAL DAYS",
    "home.trackRecord.gain": "% GAIN",
    "home.trackRecord.technical": "TECHNICAL",
    "home.trackRecord.fundamental": "FUNDAMENTAL",
    "home.trackRecord.strength": "STRENGTH",
    "home.trackRecord.days": "days",

    "home.detailUpperCase": "DETAIL",

    // Signal detail page
    "signalDetail.overview.title": "Stock Overview",
    "signalDetail.overview.company": "Company",
    "signalDetail.overview.description": "Description",
    "signalDetail.overview.si": "S/I",
    "signalDetail.overview.marketCapitalization": "Market Capitalization",
    "signalDetail.overview.nextEarning": "Next Earnings Date",
    "signalDetail.overview.showMore": "Show more",
    "signalDetail.overview.showLess": "Show less",

    "signalDetail.indicators.title": "Key Indicators",
    "signalDetail.indicators.currentStatus": "Current Status",
    "signalDetail.indicators.pendingPrice": "Pending Price",
    "signalDetail.indicators.maximumProfit": "Maximum Profit",
    "signalDetail.indicators.signalPrice": "Signal Price",
    "signalDetail.indicators.signalVolume": "Signal Volume",
    "signalDetail.indicators.triggeredPrice": "Triggered Price",
    "signalDetail.indicators.triggeredVolume": "Triggered Volume",
    "signalDetail.indicators.marketSentiment": "Market Sentiment Indicator",
    "signalDetail.indicators.technical": "Technical Indicator",
    "signalDetail.indicators.fundamental": "Fundamental Indicator",
    "signalDetail.indicators.strength": "Strength Indicator",
    "signalDetail.indicators.quality": "Quality Indicator",
    "signalDetail.indicators.proximity": "Proximity Indicator",
    "signalDetail.indicators.rsi": "Current RSI",
    "signalDetail.indicators.macd": "Current MACD",
    "signalDetail.indicators.allTimeHigh": "All-Time High",
    "signalDetail.indicators.52wRange": "52-Week Range",
    "signalDetail.indicators.50dayMa": "50-Day Moving Average (MA50)",
    "signalDetail.indicators.200dayMa": "200-Day Moving Average (MA200)",

    "signalDetail.earnings.title": "Last Earning Reports",
    "signalDetail.earnings.reportDate": "REPORT DATE",
    "signalDetail.earnings.estimated": "ESTIMATED",
    "signalDetail.earnings.reported": "REPORTED",
    "signalDetail.earnings.fiscalDateEnding": "FISCAL DATE ENDING",
    "signalDetail.earnings.surprise": "SURPRISE",

    "signalDetail.financial.title": "Financial Indicators",
    "signalDetail.financial.peRatio": "P/E Ratio",
    "signalDetail.financial.profitMargin": "Profit Margin",
    "signalDetail.financial.eps": "EPS (Earnings Per Share)",
    "signalDetail.financial.roa": "Return on Assets (ROA)",
    "signalDetail.financial.roe": "Return on Equity (ROE)",
    "signalDetail.financial.balanceSheet": "Balance Sheet (Quarterly)",
    "signalDetail.financial.balanceSheet.fiscalDateEnding": "Fiscal Date Ending",
    "signalDetail.financial.balanceSheet.totalShareholderEquity": "Shareholders",
    "signalDetail.financial.balanceSheet.totalLiabilities": "Liabilities",
    "signalDetail.financial.balanceSheet.debtToEquityRatio": "Debt/Equity Ratio",
    "signalDetail.financial.incomeStatement": "Income Statement (Quarterly)",
    "signalDetail.financial.incomeStatement.fiscalDateEnding": "Fiscal Date Ending",
    "signalDetail.financial.incomeStatement.revenue": "Revenue",
    "signalDetail.financial.incomeStatement.netIncome": "Net Income",

    // My signals page
    "mySignals.title": "My Signals",
    "mySignals.help": "List of signals that have been marked as favorites",
    "mySignals.filter.tickerName": "Ticker / Name",
    "mySignals.filter.sector": "Sector",
    "mySignals.filter.status": "Status",
    "mySignals.filter.status.pending": "Pending",
    "mySignals.filter.status.active": "Active",
    "mySignals.filter.status.activeToday": "Active (today)",
    "mySignals.filter.status.closed": "Closed",
    "mySignals.table.ticker": "TICKER",
    "mySignals.table.sector": "SECTOR",
    "mySignals.table.signalPrice": "SIGNAL PRICE",
    "mySignals.table.statusPrice": "STATUS PRICE",
    "mySignals.table.status": "STATUS",
    "mySignals.table.technical": "TECHNICAL",
    "mySignals.table.fundamental": "FUNDAMENTAL",
    "mySignals.table.strength": "STRENGTH",
    "mySignals.table.empty": "There are no signals marked as favorites",
    "mySignals.table.footer.pageable": "Results per page",

    // Active signals page
    "activeSignals.title": "Active Signals",
    "activeSignals.help": "List of signals that are currently active",
    "activeSignals.filter.tickerName": "Ticker / Name",
    "activeSignals.filter.sector": "Sector",
    "activeSignals.filter.signalDate": "Signal Date",
    "activeSignals.filter.signalPrice": "Signal Price",
    "activeSignals.filter.signalVolume": "Signal Volume",
    "activeSignals.table.ticker": "TICKER",
    "activeSignals.table.sector": "SECTOR",
    "activeSignals.table.signalPrice": "SIGNAL PRICE",
    "activeSignals.table.signalVolume": "SIGNAL VOLUME",
    "activeSignals.table.status": "STATUS",
    "activeSignals.table.technical": "TECHNICAL",
    "activeSignals.table.fundamental": "FUNDAMENTAL",
    "activeSignals.table.strength": "STRENGTH",
    "activeSignals.table.empty": "No data available",
    "activeSignals.table.footer.pageable": "Results per page",

    // Potential signals page
    "potentialSignals.title": "Potential Signals",
    "potentialSignals.help": "List of potential signals that may appear in the coming days",
    "potentialSignals.filter.tickerName": "Ticker / Name",
    "potentialSignals.filter.sector": "Sector",
    "potentialSignals.filter.createdDate": "Created Date",
    "potentialSignals.filter.signalPrice": "Signal Price",
    "potentialSignals.filter.signalVolume": "Signal Volume",
    "potentialSignals.table.ticker": "TICKER",
    "potentialSignals.table.sector": "SECTOR",
    "potentialSignals.table.signalPrice": "SIGNAL PRICE",
    "potentialSignals.table.lastVolume": "LAST VOLUME",
    "potentialSignals.table.pendingPrice": "PENDING PRICE",
    "potentialSignals.table.technical": "TECHNICAL",
    "potentialSignals.table.fundamental": "FUNDAMENTAL",
    "potentialSignals.table.strength": "STRENGTH",
    "potentialSignals.table.empty": "No data available",
    "potentialSignals.table.footer.pageable": "Results per page",

    // Closed signals page
    "closedSignals.title": "Closed Signals",
    "closedSignals.help": "List of signals that have concluded in the last week",
    "closedSignals.filter.tickerName": "Ticker / Name",
    "closedSignals.filter.sector": "Sector",
    "closedSignals.filter.signalDate": "Signal Date",
    "closedSignals.filter.finishDate": "Finish Date",
    "closedSignals.filter.signalPrice": "Signal Price",
    "closedSignals.filter.signalVolume": "Signal Volume",
    "closedSignals.table.ticker": "TICKER",
    "closedSignals.table.sector": "SECTOR",
    "closedSignals.table.signalDate": "SIGNAL DATE",
    "closedSignals.table.finishDate": "FINISH DATE",
    "closedSignals.table.signalVolume": "SIGNAL VOLUME",
    "closedSignals.table.percentageGain": "% GAIN",
    "closedSignals.table.technical": "TECHNICAL",
    "closedSignals.table.fundamental": "FUNDAMENTAL",
    "closedSignals.table.strength": "STRENGTH",
    "closedSignals.table.empty": "No data available",
    "closedSignals.table.footer.pageable": "Results per page",

    // Track record page
    "trackRecord.title": "Our Track Record",
    "trackRecord.help": "Best signals identified in the last three months",
    "trackRecord.filter.tickerName": "Ticker / Name",
    "trackRecord.filter.sector": "Sector",
    "trackRecord.filter.signalDate": "Signal Date",
    "trackRecord.filter.finishDate": "Finish Date",
    "trackRecord.filter.signalPrice": "Signal Price",
    "trackRecord.filter.signalVolume": "Signal Volume",
    "trackRecord.table.ticker": "TICKER",
    "trackRecord.table.sector": "SECTOR",
    "trackRecord.table.signalDate": "SIGNAL DATE",
    "trackRecord.table.finishDate": "FINISH DATE",
    "trackRecord.table.signalVolume": "SIGNAL VOLUME",
    "trackRecord.table.percentageGain": "% GAIN",
    "trackRecord.table.technical": "TECHNICAL",
    "trackRecord.table.fundamental": "FUNDAMENTAL",
    "trackRecord.table.strength": "STRENGTH",
    "trackRecord.table.empty": "No data available",
    "trackRecord.table.footer.pageable": "Results per page",

    // Statistics page
    "statistics.pki.potentialSignals.title": "Potential Signals",
    "statistics.pki.potentialSignals.now": "Now",
    "statistics.pki.potentialSignals.new": "New potential signals",
    "statistics.pki.potentialSignals.total": "Total",
    "statistics.pki.potentialSignals.help": "Current potential signals and summary of new signals detected in the last week of sessions",
    "statistics.pki.activeSignals.title": "Active Signals",
    "statistics.pki.activeSignals.now": "Now",
    "statistics.pki.activeSignals.new": "New active signals",
    "statistics.pki.activeSignals.total": "Total",
    "statistics.pki.activeSignals.help": "Current active signals and summary of active signals detected in the last week of sessions",
    "statistics.pki.closedSignals.title": "Closed signals",
    "statistics.pki.closedSignals.help": "Closed signals from last week and summary of success and failure signals",
    "statistics.pki.closedSignals.closed": "Closed",
    "statistics.pki.closedSignals.success": "Success",
    "statistics.pki.closedSignals.failure": "Failure",
    "statistics.pki.successRate.title": "Success Rate",
    "statistics.pki.successRate.help": "Summary of success rate of activated signals across different time frames",
    "statistics.pki.successRate.week": "Week",
    "statistics.pki.successRate.month": "Month",
    "statistics.pki.successRate.threeMonths": "3 Months",
    "statistics.tabs.daily": "Daily",
    "statistics.tabs.weekly": "Weekly",
    "statistics.tabs.monthly": "Monthly",
    "statistics.charts.potentialSignals.title": "Potential Signals",
    "statistics.charts.potentialSignals.help": "Evolution of available potential signals",
    "statistics.charts.potentialSignals.high": "High",
    "statistics.charts.potentialSignals.likely": "Likely",
    "statistics.charts.potentialSignals.eventual": "Eventual",
    "statistics.charts.activeSignals.title": "Active Signals",
    "statistics.charts.activeSignals.help": "Evolution of active signals",
    "statistics.charts.activeSignals.total": "Total",
    "statistics.charts.closedSignals.title": "Closed Signals",
    "statistics.charts.closedSignals.help": "Evolution of closed signals",
    "statistics.charts.closedSignals.total": "Total",
    "statistics.charts.closedSignals.success": "Success",
    "statistics.charts.closedSignals.failure": "Failure",
    "statistics.charts.successRate.title": "Success Rate",
    "statistics.charts.successRate.help": "Evolution of success rate",
    "statistics.charts.successRate.rate": "Rate",
    "statistics.charts.averageProfit.title": "Maximum Average Profit Per Signal",
    "statistics.charts.averageProfit.help": "Evolution of maximum average profit per signal",
    "statistics.charts.averageProfit.avgProfit": "AVG Profit",
    "statistics.charts.resultDistribution.title": "Distribution Of Results",
    "statistics.charts.resultDistribution.help": "Signal distribution according to profit range",

    // Market sentiment page
    "marketSentiment.now.title": "Now",
    "marketSentiment.now.help": "Current market sentiment (updated every 15 minutes)",
    "marketSentiment.today.title": "Today",
    "marketSentiment.today.help": "Average market sentiment of today",
    "marketSentiment.week.title": "Last Week",
    "marketSentiment.week.help": "Average market sentiment of last week",
    "marketSentiment.month.title": "Last Month",
    "marketSentiment.month.help": "Average market sentiment of last month",
    "marketSentiment.evolutionChart.title": "Evolution of Sentiment",
    "marketSentiment.evolutionChart.help": "Evolution of market sentiment across the different time frames",
    "marketSentiment.evolutionChart.item.daily": "Daily Average",
    "marketSentiment.evolutionChart.item.weekly": "Weekly Average",
    "marketSentiment.evolutionChart.item.monthly": "Monthly Average",

    // Stock chart component
    "component.stockChart.menu.title": "Candlestick Chart",
    "component.stockChart.menu.fullscreen": "Full screen",
    "component.stockChart.menu.configuration": "Configuration",
    "component.stockChart.modal.configuration.stoploss": "Stoploss line",
    "component.stockChart.modal.configuration.breakout": "Breakout line",
    "component.stockChart.modal.configuration.target": "Target line",
    "component.stockChart.modal.configuration.signalLine": "Signal line detail",
    "component.stockChart.stoploss": "Stoploss",
    "component.stockChart.breakout": "Breakout",
    "component.stockChart.target": "Target",

    // Error page
    "errorPage.message1": "Oops. Looks like the page you're looking for no longer exists",
    "errorPage.message2": "But we're here to bring you back to safety",
    "errorPage.button": "Back to Home",

    // Binance Dashboard
    "dashboard.title": "Dashboard",
    "dashboard.subtitle": "Trading Bot Performance Overview",

    "dashboard.filter.all": "All data",
    "dashboard.filter.lastYear": "Last year",
    "dashboard.filter.currentYear": "Current year",
    "dashboard.filter.sexMonths": "Last 6 months",
    "dashboard.filter.threeMonths": "Last 3 months",
    "dashboard.filter.thirtyDays": "Last 30 days",
    "dashboard.filter.sevenDays": "Last 7 days",

    "dashboard.table.title": "Trade History",
    "dashboard.table.header.side": "Side",
    "dashboard.table.header.status": "Status",
    "dashboard.table.header.entryPrice": "Entry Price",
    "dashboard.table.header.exitPrice": "Exit Price",
    "dashboard.table.header.exitType": "Exit Type",
    "dashboard.table.header.pnl": "P&L",
    "dashboard.table.header.pnlPct": "P&L %",
    "dashboard.table.header.date": "Date",
    "dashboard.table.modeLong": "Long",
    "dashboard.table.modeShort": "Short",
    "dashboard.table.open": "Open",
    "dashboard.table.closed": "Closed",
    "dashboard.table.tp": "Take Profit",
    "dashboard.table.sl": "Stop Loss",
    "dashboard.table.timestop": "Time Stop",
    "dashboard.table.search": "Search",
};